import React, { ReactNode } from 'react'
import { Auth0Context, Auth0ContextInterface } from '@auth0/auth0-react'

// A fake Auth0 context value that reports the user as authenticated, so the
// dashboard renders without a real Auth0 tenant. getAccessTokenSilently returns
// a dummy token (the mock Apollo link ignores it anyway).
const mockAuth0 = {
    isAuthenticated: true,
    isLoading: false,
    user: {
        name: 'Dev User',
        nickname: 'dev',
        picture: 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp',
    },
    getAccessTokenSilently: async () => 'mock-access-token',
    getAccessTokenWithPopup: async () => 'mock-access-token',
    getIdTokenClaims: async () => undefined,
    loginWithRedirect: async () => undefined,
    loginWithPopup: async () => undefined,
    logout: () => undefined,
    handleRedirectCallback: async () => ({ appState: undefined }),
    buildAuthorizeUrl: async () => '',
    buildLogoutUrl: () => '',
} as unknown as Auth0ContextInterface

export function MockAuth0Provider({ children }: { children: ReactNode }): JSX.Element {
    return <Auth0Context.Provider value={mockAuth0}>{children}</Auth0Context.Provider>
}
